// ServiceDetailPage.js
import React from "react";
import { useParams, Link } from "react-router-dom";
import { servicesData } from "./servicesData"; 
import "./ServiceDetailPage.css";

const ServiceDetailPage = () => {
  const { id } = useParams();
  const serviceId = parseInt(id);
  const service = servicesData.find((s) => s.id === serviceId);

  if (!service) {
    return <div>Service not found!</div>;
  }

  return (
    <div className="service-detail">
      <h1>{service.title}</h1>
      <p>{service.description}</p>
      <ul>
        {service.details.map((detail, index) => (
          <li key={index}>{detail}</li>
        ))}
      </ul>
      <Link to="/services" className="back-link">
        Back to Services
      </Link>
    </div>
  );
};

export default ServiceDetailPage;